import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import React, { useEffect, useState } from "react";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import PrincipalEntity from "./pages/PrincipalEntity";
import Template from "./pages/Template";
import CustomerSmsReport from "./pages/CustomerSmsReport";
import CustomerMonthlyReport from "./pages/CustomerMonthlyReport";
import BlackListPage from "./pages/BlackListPage";
import ForgotPassword from "./pages/ForgotPassword";
// import VerifyOtp from "./pages/VerifyOtp";
import ResetPassword from "./pages/ResetPassword";
import Smspanel from "./component/smspanel/smspanel";
import ProfileDetail from "./pages/ProfileDetail";
import ManageCustomer from "./pages/ManageCustomer";
import Layout from "./component/layout/Layout";
import AccessDenied from "./pages/AccessDenied";
import PageNotFound from "./pages/PageNotFound";
import ManageKYC from "./pages/ManageKYC";
import ShortLink from "./pages/ShortLink";
import UnicodeFinder from "./pages/UnicodeFinder";
import DeliveryReport from "./pages/DeliveryReport";
import ScheduledSMS from "./pages/ScheduledSMS";
import ResellerScheduledSMS from "./pages/ResellerScheduledSMS";
import APIReport from "./pages/APIReport";
import ResellerAPIReport from "./pages/resellerapireport";
import StartClicker from "./pages/StartClicker";
import ManageCampaning from "./pages/ManageCampaign";
import SiteSetting from "./pages/SiteSetting";
import ConsolidateReport from "./pages/ConsolidateReport";
import MISReport from "./pages/MISReport";
import ResellerMISReport from "./pages/ResellerMISReport";
import CreditHistory from "./pages/CreditHistory";
import TransactionHistory from "./pages/TransactionHistory";
import TodayCustomerReport from "./pages/TodayCustomerReport";
import SampleCodeTabs from "./pages/SampleCodeTabs";
import ApiDocument from "./pages/ApiDocument";
import NumbersByCampaignPage from "./pages/NumbersByCampaignPage";
import ProfilePage from "./pages/ProfilePage";
import CreateCampaign from "./pages/CreateCampaion";
import ChangePasswordForm from "./pages/ChangePasswordForm";
import ServiceDropdown1 from "./component/smspanel/smspanel2";
import SelectMobileForOtp from "./pages/SelectMobileForOtp";
import TermAndCondtions from "./pages/TermAndCondtions";
import CreateHeader from "./pages/CreateHeader";
import ChangePassword from "./pages/ChangePassword";
import RcsTemplateList from "./pages/rcsManageTemplate";
// import TemplateForm from "./pages/rcsTemplate";
import RCSComponent from "./component/smspanel/rcs/RCSComponent";
import TemplateForm from "./pages/rcsTemplate copy";
import TruecallerCampign from "./component/smspanel/trueCaller/TruecallerComponent";
// import TemplateForm from "./pages/rcsTemplate";
import MangeMpin from "./pages/MangeMpin";
import ConsolidateReportCount from "./pages/ConsolidateReportCount";
import CreateDB from "./pages/CreateDB";
import UploadDataDB from "./pages/UploadDataDB";
import ViewDataFields from "./pages/ViewDataFields";
import TruecallerTemplate from "./pages/truecallerTemplate";
import WhatsappList from "./pages/WhatsappList";
import WhatsappTemplate from "./pages/WhatsappTemplate";
import WhatsappComponent from "./pages/whatsappCampaign";
import DataRecord from "./pages/dataRecord";
import LiveChat from "./pages/LiveChat";
import WabaNumber from "./pages/wabaNumber";
import ManageApiKey from "./pages/ManageApiKey";
import MissedCall from "./pages/MissedCall";
import CallReport from "./pages/CallReport";
import RcscampaignList from "./pages/rcsCampaignList";
import EventCreation from "./pages/eventCreation";
import KeywordForm from "./pages/shortcode";
import SortCode from "./pages/SortCode";
import KeywordReport from "./pages/KeywordReport";
import CreateContacts from "./pages/CreateContacts";
import WorkFlow from "./pages/WorkFlow";
import WorkflowBuilder from "./pages/WorkflowBuilder";
import OutboundSmsConfig from "./pages/OutboundSmsConfig";
import WhatsappConfig from "./pages/WhatsappConfig";
import RcsConfig from "./pages/RcsConfig";
import RCSbot from "./pages/bot";
import BotsList from "./pages/botlist";
import WorkflowEdit from "./pages/WorkflowEdit";
import CreateAgentForm from "./pages/LiveAgent";
import FlowReport from "./pages/FlowReport";
import ChatbotFlowBuilder from "./pages/ChatbotFlowBuilder";
import DownloadCenter from "./pages/DownloadCenter";
import { Category } from "@mui/icons-material";
import ManageCategory from "./pages/ManageCategory";
import EmailCampaignReport from "./pages/EmailCampaignReport";
import CreateEmailCampaign from "./pages/EmailCampaign";
import EmailTemplateBuilder from "./pages/EmailTemplate";
import MyRates from "./pages/MyRates";
import { ThemeProvider } from "@mui/material/styles";
import glassTheme from "./theme";
import { useGetCustomerLogDeleteKeyQuery } from "./store/services/reportApi";
import RcsCampaignDetailsPage from "./pages/RcsCampaignDetailsPage";
import ResellerRcsCampaignDetailsPage from "./pages/ResellerRcsCampaignDetailsPage";
import WhatsappDetailPage from "./pages/whatsappdetailsreport";
import WhatsAppNumberQuality from "./pages/WhatsAppNumberQuality";
import EmailTemplatesList from "./pages/emialtemplatelist";
// import UnifiedSMS from "./pages/UnifiedSMS";
import Dlrurl from "./pages/dlrUrlmanagment";
import Apisentreport from "./pages/apiSentreport";
import Apidownload from "./pages/apiDocsdownload";
import llmWhatsappTemplate from "./pages/llmWhatsapptemplate";
import LlmWhatsappTemplate from "./pages/llmWhatsapptemplate";
import LlmWhatsappList from "./pages/whatsappllmtemplist";


function App() {
  const [reseller, setReseller] = useState(
    localStorage.getItem("reseller") === "true",
  );

  const { data: featureKeyData, isLoading: featureLoading } =
    useGetCustomerLogDeleteKeyQuery();

  const canShowWorkflow = featureKeyData?.data?.is_workflow_given === true;
  useEffect(() => {
    const handleStorageChange = () => {
      setReseller(localStorage.getItem("reseller") === "true");
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);
  const ProtectedRoute = ({
    element,
    redirectTo = "/un-authorised-request",
  }) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return <Navigate to={redirectTo} />;
    }

    return element;
  };
  const WorkflowProtectedRoute = ({
    element,
    redirectTo = "/un-authorised-request",
  }) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return <Navigate to="/login" />;
    }

    if (featureLoading) {
      return null;
    }

    if (!canShowWorkflow) {
      return <Navigate to={redirectTo} />;
    }

    return element;
  };

  return (
    <ThemeProvider theme={glassTheme}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/initial-change-password" element={<ChangePassword />} />
          <Route path="/verify-otp" element={<SelectMobileForOtp />} />
          <Route path="/terms-and-conditions" element={<TermAndCondtions />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="*" element={<PageNotFound />} />
          <Route path="/un-authorised-request" element={<AccessDenied />} />
          <Route
            path="/"
            element={
              <ProtectedRoute element={<Layout />} redirectTo="/login" />
            }
          >
            <Route index element={<ProtectedRoute element={<Dashboard />} />} />
            <Route
              path="/blacklist"
              element={<ProtectedRoute element={<BlackListPage />} />}
            />
            <Route
              path="/smspanel"
              element={<ProtectedRoute element={<Smspanel />} />}
            />
            <Route
              path="/managekyc"
              element={<ProtectedRoute element={<ManageKYC />} />}
            />
            <Route
              path="/managempin"
              element={<ProtectedRoute element={<MangeMpin />} />}
            />
            <Route
              path="/apikey"
              element={<ProtectedRoute element={<ManageApiKey />} />}
            />
            <Route
              path="/missedcall"
              element={<ProtectedRoute element={<MissedCall />} />}
            />
            <Route
              path="/callreport"
              element={<ProtectedRoute element={<CallReport />} />}
            />
            <Route
              path="/keyword"
              element={<ProtectedRoute element={<SortCode />} />}
            />
            <Route
              path="/keywordreport"
              element={<ProtectedRoute element={<KeywordReport />} />}
            />
            <Route
              path="/contacts"
              element={<ProtectedRoute element={<CreateContacts />} />}
            />
            <Route
              path="/workflow"
              element={<WorkflowProtectedRoute element={<WorkFlow />} />}
            />
            <Route
              path="/workflow/:id"
              element={<WorkflowProtectedRoute element={<WorkflowBuilder />} />}
            />
            <Route
              path="/workflow/:id/sms"
              element={
                <WorkflowProtectedRoute element={<OutboundSmsConfig />} />
              }
            />
            <Route
              path="/workflow/:id/whatsapp"
              element={<WorkflowProtectedRoute element={<WhatsappConfig />} />}
            />
            <Route
              path="/workflow/:id/rcs"
              element={<WorkflowProtectedRoute element={<RcsConfig />} />}
            />
            <Route
              path="/workflow/edit/:cfId"
              element={<WorkflowProtectedRoute element={<WorkflowEdit />} />}
            />
            <Route
              path="/shortlink"
              element={<ProtectedRoute element={<ShortLink />} />}
            />
            <Route
              path="/unicodefinder"
              element={<ProtectedRoute element={<UnicodeFinder />} />}
            />
            <Route
              path="/deliveryreport"
              element={<ProtectedRoute element={<DeliveryReport />} />}
            />
            {/* <Route
              path="/clickerreport"
              element={<ProtectedRoute element={<ClickerReport />} />}
            /> */}
            <Route
              path="/scheduledsms"
              element={<ProtectedRoute element={<ScheduledSMS />} />}
            />
            <Route
            path="/reseller-scheduledsms"
            element={
              <ProtectedRoute element={<ResellerScheduledSMS />} />
            }
            />
            <Route
              path="/consolidatereport"
              element={<ProtectedRoute element={<ConsolidateReport />} />}
            />
            <Route
              path="/misreport"
              element={<ProtectedRoute element={<MISReport />} />}
            />
            <Route
              path="/reseller-misreport"
              element={<ProtectedRoute element={<ResellerMISReport />} />}
            />
            <Route
              path="/transactionhistory"
              element={<ProtectedRoute element={<TransactionHistory />} />}
            />
            <Route
              path="/credithistory"
              element={<ProtectedRoute element={<CreditHistory />} />}
            />
            <Route
              path="/apireport"
              element={<ProtectedRoute element={<APIReport />} />}
            />
            <Route
              path="/samplecode"
              element={<ProtectedRoute element={<SampleCodeTabs />} />}
            />
            <Route
              path="/apidocumentation"
              element={<ProtectedRoute element={<ApiDocument />} />}
            />
            <Route
              path="/ManageForwardLink"
              element={<ProtectedRoute element={<StartClicker />} />}
            />
            <Route
              path="/ManageCampaign"
              element={<ProtectedRoute element={<ManageCampaning />} />}
            />
            <Route
              path="/principalentity"
              element={<ProtectedRoute element={<PrincipalEntity />} />}
            />
            <Route
              path="/customersmsreport"
              element={<ProtectedRoute element={<CustomerSmsReport />} />}
            />
            <Route
              path="/customermonthlyreport"
              element={<ProtectedRoute element={<CustomerMonthlyReport />} />}
            />
            <Route
              path="/consolidatereportcount"
              element={<ProtectedRoute element={<ConsolidateReportCount />} />}
            />
            <Route
              path="/template"
              element={<ProtectedRoute element={<Template />} />}
            />
            <Route
              path="/managecustomer"
              element={
                <ProtectedRoute
                  element={reseller ? <ManageCustomer /> : <AccessDenied />}
                />
              }
            />{" "}
            <Route
              path="/ManageSetting"
              element={<ProtectedRoute element={<SiteSetting />} />}
            />
            <Route
              path="/CustomerTodaySmsReport"
              element={<ProtectedRoute element={<TodayCustomerReport />} />}
            />
            <Route
              path="/profile/:customer_id"
              element={<ProtectedRoute element={<ProfileDetail />} />}
            />
            <Route
              path="/numbersbycampaign/:campaign_id/:status"
              element={<ProtectedRoute element={<NumbersByCampaignPage />} />}
            />
            <Route
              path="/profile"
              element={<ProtectedRoute element={<ProfilePage />} />}
            />
            <Route
              path="/my-rates"
              element={<ProtectedRoute element={<MyRates />} />}
            />
            <Route
              path="/managecategory"
              element={<ProtectedRoute element={<ManageCategory />} />}
            />
            <Route
              path="/createcampaign"
              element={<ProtectedRoute element={<CreateCampaign />} />}
            />
            <Route path="/createcampaign/:id" element={<CreateCampaign />} />
            <Route
              path="/change-password"
              element={<ProtectedRoute element={<ChangePasswordForm />} />}
            />
            <Route
              path="/sms-panel"
              element={<ProtectedRoute element={<ServiceDropdown1 />} />}
            />
            {/* <Route
              path="/unified-sms"
              element={<ProtectedRoute element={<UnifiedSMS />} />}
            /> */}
            <Route
              path="/create-header"
              element={<ProtectedRoute element={<CreateHeader />} />}
            />
            <Route
              path="/rcs-template-list"
              element={<ProtectedRoute element={<RcsTemplateList />} />}
            />
            <Route
              path="/rcs-template"
              element={<ProtectedRoute element={<TemplateForm />} />}
            />
            <Route
              path="/rcs-component"
              element={<ProtectedRoute element={<RCSComponent />} />}
            />
            <Route
              path="/truecaller-campaign"
              element={<ProtectedRoute element={<TruecallerCampign />} />}
            />
            <Route
              path="/create-db"
              element={<ProtectedRoute element={<CreateDB />} />}
            />
            <Route
              path="/upload-data"
              element={<ProtectedRoute element={<UploadDataDB />} />}
            />
            <Route
              path="/view-dbdata"
              element={<ProtectedRoute element={<ViewDataFields />} />}
            />
            <Route
              path="/data-record"
              element={<ProtectedRoute element={<DataRecord />} />}
            />
            <Route
              path="/truecaller-template"
              element={<ProtectedRoute element={<TruecallerTemplate />} />}
            />
            <Route
              path="/whatsapp-list"
              element={<ProtectedRoute element={<WhatsappList />} />}
            />
            <Route
              path="/whatsapp-template"
              element={<ProtectedRoute element={<WhatsappTemplate />} />}
            />
            <Route
            path="/Ai-template"
            element={<ProtectedRoute element={<LlmWhatsappTemplate/>}/>}/>

            <Route
            path="/llm-template"
            element={<ProtectedRoute element={<LlmWhatsappList/>}/>}/>

            <Route
              path="/whatsapp-number-quality"
              element={<ProtectedRoute element={<WhatsAppNumberQuality />} />}
            />

            <Route
              path="/whatsapp-campaign"
              element={<ProtectedRoute element={<WhatsappComponent />} />}
            />
            <Route
              path="/whatsapp-live-chat"
              element={<ProtectedRoute element={<LiveChat />} />}
            />
            <Route
              path="/whatsapp-waba-number"
              element={<ProtectedRoute element={<WabaNumber />} />}
            />
            <Route
              path="/rcs-campaign-list"
              element={<ProtectedRoute element={<RcscampaignList />} />}
            />
            <Route
              path="/keyword-form"
              element={<ProtectedRoute element={<KeywordForm />} />}
            />
            <Route
              path="/rcs-campaign-list"
              element={<ProtectedRoute element={<RcscampaignList />} />}
            />
            <Route
              path="/rcs-campaign-details/:campaignId"
              element={<ProtectedRoute element={<RcsCampaignDetailsPage />} />}
            />
            <Route
              path="/reseller-rcs-campaign-details/:campaignId"
              element={
                <ProtectedRoute element={<ResellerRcsCampaignDetailsPage />} />
              }
            />
            <Route
              path="/whatsappdetailpage/:campaign_id"
              element={
                <ProtectedRoute
                  element={
                    <div className="pagination-style-exempt">
                      <WhatsappDetailPage />
                    </div>
                  }
                />
              }
            />

            <Route
              path="/keyword-form"
              element={<ProtectedRoute element={<KeywordForm />} />}
            />
            <Route
              path="/rcs-bot"
              element={<ProtectedRoute element={<RCSbot />} />}
            />
            <Route
              path="/rcs-bot-list"
              element={<ProtectedRoute element={<BotsList />} />}
            />
            <Route
              path="/create-agent"
              element={<ProtectedRoute element={<CreateAgentForm />} />}
            />
            <Route
              path="/flow-report"
              element={<WorkflowProtectedRoute element={<FlowReport />} />}
            />
            <Route
              path="/flow-designer"
              element={<ProtectedRoute element={<ChatbotFlowBuilder />} />}
            />
            <Route
              path="/download-center"
              element={<ProtectedRoute element={<DownloadCenter />} />}
            />
            <Route
              path="/email-campaign-report"
              element={<ProtectedRoute element={<EmailCampaignReport />} />}
            />
            <Route
              path="/email-campaign"
              element={<ProtectedRoute element={<CreateEmailCampaign />} />}
            />
            <Route
              path="/category"
              element={<ProtectedRoute element={<ManageCategory />} />}
            />
            <Route
              path="/email-template"
              element={<ProtectedRoute element={<EmailTemplateBuilder />} />}
            />
            <Route
              path="/email-template-list"
              element={<ProtectedRoute element={<EmailTemplatesList />} />}
            />
            <Route
              path="/event-creation"
              element={<ProtectedRoute element={<EventCreation />} />}
            />
            <Route
            path="/dlr-url"
            element={<ProtectedRoute element={<Dlrurl />} />}
              />
              <Route
              path = "/api-docs-download"
              element = {<ProtectedRoute element={<Apidownload/>}/>}
              />
              <Route
              path="/api-sent-report"
              element={<ProtectedRoute element={<Apisentreport/>}/>}/>
              <Route
                path="/resseller-api-report"
                element={<ProtectedRoute element={<ResellerAPIReport />} />}
              />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
